import { render, staticRenderFns } from "./GridCellHeader.vue?vue&type=template&id=1b8bd32c&scoped=true&"
import script from "./GridCellHeader.vue?vue&type=script&lang=js&"
export * from "./GridCellHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8bd32c",
  null
  
)

export default component.exports